module.exports = __webpack_public_path__ + "img/6.3-打造港口运营数字化底座.fdb77840.png";